export enum Roles {
    ADMINISTRATOR = 'ADMINISTRATOR',
    USER = 'USER',
}
